// client/src/routes/portal/settings.tsx — „Setări”, the portal's settings page · D-3306.
//
// NOT a sixth tab. §6.6's five tabs stay five, because five is what its 360 px row holds and a
// settings page is not a place a renter goes every week; the way in is the user menu's „Setări”,
// which is now the menu's only entry beside „Deconectare”. The bell's `/portal/notifications` is
// the precedent for a portal route that is not a tab (D-1171).
//
// Until D-3306 the things on this page were six dialogs the user menu opened one at a time, on
// the reasoning that a profile form and a one-way confirmation are single tasks with nothing worth
// a route. That stopped being true once the list grew to profile, address, mail switches,
// password, sessions, the owner's role and the deletion: a menu of seven rows was the settings
// page, drawn in the one place that cannot scroll, and the mail's „Preferințe de notificare” link
// needed a page to land on anyway. The Product Owner's request collapsed the menu; this route is
// where its rows went.
//
// `?section=` is the page's only state of its own, and `contract` is the layout's and is simply
// carried (D-1180): nothing here reads a lease, but the tab a renter takes next must still show
// the one they were reading.

import { createFileRoute } from '@tanstack/react-router';

import { PortalSettings } from '@/features/portal/PortalSettings';
import { portalSettingsSearchSchema } from '@/features/portal/search';

export const Route = createFileRoute('/portal/settings')({
  validateSearch: portalSettingsSearchSchema,
  component: PortalSettingsScreen,
});

function PortalSettingsScreen() {
  const { section } = Route.useSearch();
  return <PortalSettings section={section} />;
}
